export default {
    indexBaseHours:     { method: 'get',    url: 'base_hours' },
    createBaseHour:     { method: 'post',   url: 'base_hours' },
    updateBaseHour:     { method: 'put',    url: 'base_hours/{id}' },
    deleteBaseHour:     { method: 'delete', url: 'base_hours/{id}' },
}